import { ELabelColor, ILabel } from '../../../types/label';

export function getPledgeRealtyLabel(): ILabel {
  return {
    text: 'Залоговая недвижимость',
    color: ELabelColor.Gray,
  };
}
